import { fishboneDirection_Horizontal, fishboneDirection_Vertical } from './types.js';
const defaultFishbone_CBC = {
    key: 'cbc',
    label: 'Complete Blood Count - CBC',
    direction: fishboneDirection_Horizontal,
    ribs: [
        { ribItems: [{ variableIds: ['hemoglobin'], shortName: 'Hgb' }] },
        { ribItems: [{ variableIds: ['hematocrit'], shortName: 'Hct' }] },
    ],
    head: { variableIds: ['WBC'], shortName: 'WBC' },
    tail: { variableIds: ['platelets count'], shortName: 'Plt' }
};
const defaultFishbone_BMP = {
    key: 'bmp',
    label: 'Basic Metabolic Panel',
    direction: fishboneDirection_Horizontal,
    ribs: [
        {
            ribItems: [
                { variableIds: ['sodium'], shortName: 'Na' },
                { variableIds: ['chloride'], shortName: 'Cl' },
                { variableIds: ['blood urea nitrogen'], shortName: 'BUN' }
            ]
        },
        {
            ribItems: [
                { variableIds: ['potassium'], shortName: 'K' },
                { variableIds: ['bicarbonate'], shortName: 'CO_2' },
                { variableIds: ['creatinine'], shortName: 'Cre' }
            ]
        },
    ],
    tail: { variableIds: ['glucose random'], shortName: 'Glu' },
};
const defaultFishbone_Elements = {
    key: 'elements',
    label: 'Elements',
    direction: fishboneDirection_Vertical,
    ribs: [
        {
            ribItems: [
                { variableIds: ['calcium'], shortName: 'Ca' },
                { variableIds: ['magnesium'], shortName: 'Mg' }
            ]
        }
    ],
    tail: { variableIds: ['phosphorus'], shortName: 'Phos' },
};
const defaultFishbone_LiverDiagram = {
    key: 'liver-diagram',
    label: 'Liver Diagram',
    direction: fishboneDirection_Horizontal,
    ribs: [
        { ribItems: [{ variableIds: ['bilirubin total'], shortName: 'T BIL' }] },
        { ribItems: [{ variableIds: ['alkaline phosphatase'], shortName: 'ALK' }] },
    ],
    head: { variableIds: ['aspartate aminotransferase'], shortName: 'AST' },
    tail: { variableIds: ['alanine aminotransferase'], shortName: 'ALT' },
};
const defaultFishbone_Coagulation = {
    key: 'coagulation',
    label: 'Coagulation',
    direction: fishboneDirection_Horizontal,
    ribs: [
        { ribItems: [{ variableIds: ['prothrombin time'], shortName: 'PT' }] },
        { ribItems: [{ variableIds: ['partial thromboplastin time activated'], shortName: 'PTT' }] },
    ],
    tail: { variableIds: ['international normalized ratio'], shortName: 'INR' },
};
const defaultFishbone_HepaticPanel = {
    key: 'hepatic',
    label: 'Hepatic Panel',
    direction: fishboneDirection_Horizontal,
    ribs: [
        {
            ribItems: [
                { variableIds: ['aspartate aminotransferase'], shortName: 'AST' },
                { variableIds: ['alanine aminotransferase'], shortName: 'ALT' },
                { variableIds: ['alkaline phosphatase'], shortName: 'Alk' },
            ]
        },
        {
            ribItems: [
                { variableIds: ['calcium'], shortName: 'Ca^2' },
                { variableIds: ['total protein'], shortName: 'Pro' },
                { variableIds: ['albumin'], shortName: 'Alb' },
            ]
        }
    ],
    tail: { variableIds: ['bilirubin total'], shortName: 'T BIL' },
};
const defaultFishbone_ABG = {
    key: 'abg',
    label: 'Atrial Blood Gas - ABG',
    direction: fishboneDirection_Horizontal,
    ribs: [
        {
            slantDividers: true,
            ribItems: [
                { variableIds: ['arterial pH'], shortName: 'pH' },
                { variableIds: ['arterial PaCO 2'], shortName: 'PCO_2' },
                { variableIds: ['arterial HCO3'], shortName: 'HCO_3' },
                { variableIds: ['arterial PaO2'], shortName: 'PO_2' },
                { variableIds: ['arterial SaO 2'], shortName: 'O_2' },
            ]
        }
    ],
};
const defaultFishbone_VBG = {
    key: 'vbg',
    label: 'Venous Blood Gas - VBG',
    direction: fishboneDirection_Horizontal,
    ribs: [
        {
            slantDividers: true,
            ribItems: [
                { variableIds: ['venous pH'], shortName: 'pH' },
                { variableIds: ['venous PvCO 2'], shortName: 'PCO_2' },
                { variableIds: ['venous HCO3'], shortName: 'HCO_3' },
                { variableIds: ['venous PvO2'], shortName: 'PO_2' },
                { variableIds: ['venous SvO 2'], shortName: 'O_2' },
            ]
        }
    ],
};
const defaultFishbone_CardiacPanel = {
    key: 'cardiac panel',
    label: 'Cardiac Panel',
    direction: fishboneDirection_Horizontal,
    ribs: [
        {
            slantDividers: true,
            ribItems: [
                { variableIds: ['highly sensitive troponin I'], shortName: 'HsT I' },
                { variableIds: ['BNP'], shortName: 'BNP' },
                { variableIds: ['D-dimer'], shortName: 'D-dimer' },
            ]
        }
    ]
};
export const defaultFishbones = [
    defaultFishbone_CBC,
    defaultFishbone_BMP,
    defaultFishbone_Elements,
    defaultFishbone_LiverDiagram,
    defaultFishbone_Coagulation,
    defaultFishbone_ABG,
    defaultFishbone_HepaticPanel,
    defaultFishbone_VBG,
    defaultFishbone_CardiacPanel
];
//# sourceMappingURL=defaults.js.map